import { render, staticRenderFns } from "./PhoneNiceAuthView.vue?vue&type=template&id=43dbf520&scoped=true&"
import script from "./PhoneNiceAuthView.vue?vue&type=script&lang=js&"
export * from "./PhoneNiceAuthView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43dbf520",
  null
  
)

export default component.exports